export enum SerpCardClickTarget {
  Button = 'button',
  Reviews = 'reviews',
  Card = 'card',
}

export interface SerpCardClick {
  target: SerpCardClickTarget;
  hotelId: number;
  position: number;
  maxViewedPosition: number;
  clientUuid: string;
  sid: string;
  searchUuid: string;
}
